export default "__VITE_ASSET__cfa60c11__"